import { Route } from 'react-router-dom';
import ScheduleChangeRequests from './containers/ScheduleChangeRequests';
import VacationRequests from './containers/VacationRequests';
import ViewScheduleProgram from './containers/ViewScheduleProgram';

export default [
    <Route key="schedule-program" exact path="/schedule-program" component={ViewScheduleProgram} />,
    <Route key="vacation-requests" exact path="/vacation-requests" component={VacationRequests} />,
    <Route key="schedule-change-requests" exact path="/schedule-change-requests" component={ScheduleChangeRequests} />
]
